import { render, staticRenderFns } from "./GeneroDataTable.vue?vue&type=template&id=339b82af"
import script from "./GeneroDataTable.vue?vue&type=script&lang=js"
export * from "./GeneroDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports